

import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/auth-guard.service';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';

export const workspaceRoutes: Routes = [
  {
    path     : 'workspace',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'workspace/:magicLinkId',
    component: PlatformToolContainerComponent
  }
];
